(function () {

    GoodFaithEstimateService.$inject = ['$q', 'TeamScheduleService', 'ScheduleDataServiceV2', 'ScheduleCostsServiceV2', 'userServices', 'ShiftTemplateUtils', 'TSUsersService'];

    function GoodFaithEstimateService($q, TeamScheduleService, ScheduleDataServiceV2, ScheduleCostsServiceV2, userServices, ShiftTemplateUtils, TSUsersService) {
        var self = this;

        var cache = {};
        var gfeTemplateCache = {};
        var DAY = 24 * 3600 * 1000;
        let gfeState;

        const AUTO_EXPIRATION_RANGE_AFTER_HIRE_DATE = {
            CHICAGO: 90
        }

        const checkIfEmptyGFE = (userGfe) => {
            return !userGfe?.intervals?.length && userGfe?.weekly_hours === 0;
        }

        var prepareGFEUserMap = function (goodFaithEstimateUsers) {
            var goodFaithEstimateUsersMap = {};

            for (var i in goodFaithEstimateUsers) {
                var gfeUser = goodFaithEstimateUsers[i];
                goodFaithEstimateUsersMap[gfeUser.id] = {
                    userId: gfeUser['id'],
                    effectiveStartDate: moment(gfeUser['effective_start_date']).valueOf(),
                    weeklyHours: gfeUser['weekly_hours'],
                    hasSignificantChange: gfeUser['has_significant_change'],
                    allIntervals: gfeUser['intervals'],
                    days: {},
                    isMidweekEffectiveDate: moment(gfeUser['effective_start_date']).isAfter(moment(ScheduleDataServiceV2.startDate)),
                    isEmptyGFE : checkIfEmptyGFE(gfeUser),
                };

                let weeklyHours = 0;

                for (var j in gfeUser.intervals) {
                    var interval = gfeUser.intervals[j];
                    goodFaithEstimateUsersMap[gfeUser.id]['days'][interval.day] = goodFaithEstimateUsersMap[gfeUser.id]['days'][interval.day] || {day: interval.day, locations: {}};
                    goodFaithEstimateUsersMap[gfeUser.id]['days'][interval.day]['locations'][interval.brand_id] = goodFaithEstimateUsersMap[gfeUser.id]['days'][interval.day]['locations'][interval.brand_id] || {brandId: interval.brand_id, shifts: [], dayHours: 0};
                    goodFaithEstimateUsersMap[gfeUser.id]['days'][interval.day]['locations'][interval.brand_id]['shifts'].push(interval);
                    goodFaithEstimateUsersMap[gfeUser.id]['days'][interval.day]['dayHours'] = goodFaithEstimateUsersMap[gfeUser.id]['days'][interval.day]['dayHours'] || 0;
                    goodFaithEstimateUsersMap[gfeUser.id]['days'][interval.day]['dayHours'] += getGFEShiftDuration(interval);
                    weeklyHours += goodFaithEstimateUsersMap[gfeUser.id]['days'][interval.day]['dayHours'] ?? 0;
                }

                goodFaithEstimateUsersMap[gfeUser.id].weeklyHours ||= weeklyHours;
            }

            return goodFaithEstimateUsersMap;
        };

        var prepareUsersWorkingMap = function (scheduleShifts, usersCostsMap, goodFaithEstimateUsersMap, usersOfferedShiftsMap) {
            var usersWorkingMap = {};

            for (var i in scheduleShifts) {
                var shift = scheduleShifts[i];
                var userCosts = usersCostsMap[shift.user_id] || {};
                var userPayType = userCosts["pay_type"] && userCosts["pay_type"][shift.day];

                if (shift.status !== 'DELETED' && userPayType && userPayType['type'] === 'HOURLY') {
                    usersWorkingMap[shift.user_id] = usersWorkingMap[shift.user_id] || {weeklyHours: 0, days: {}};
                    var userGFEWork = goodFaithEstimateUsersMap[shift.user_id];
                    var isPickedUpShift = !!usersOfferedShiftsMap['pickedUpShifts'][shift.id];

                    if ((userGFEWork && moment(shift.day).valueOf() < userGFEWork['effectiveStartDate']) || isPickedUpShift) {
                        continue;
                    }

                    usersWorkingMap[shift.user_id]['weeklyHours'] += ((new Date(shift.end_time).getTime() - new Date(shift.start_time).getTime()) / 1000 / 3600);
                    usersWorkingMap[shift.user_id]['days'][shift.day_abbr] = usersWorkingMap[shift.user_id]['days'][shift.day_abbr] || {day: shift.day, day_abbr: shift.day_abbr, shifts: []};
                    usersWorkingMap[shift.user_id]['days'][shift.day_abbr]['shifts'].push(shift);
                }
            }

            var usersOfferedShifts = usersOfferedShiftsMap['usersOfferedShifts'];

            for (var userId in usersOfferedShifts) {
                var userOfferedWorks = usersOfferedShifts[userId]['weeklyHours'];

                if (usersWorkingMap[userId]) {
                    usersWorkingMap[userId]['weeklyHours'] += userOfferedWorks;
                }
            }

            return usersWorkingMap;
        };

        var addOfferedShiftDetails = function (userId, offerShift, offeredShiftsMap) {
            var shiftDay = ScheduleDataServiceV2.getShiftDay(offerShift);
            var originalShiftDay = moment(shiftDay).format("ddd").toUpperCase();

            offerShift['user_id'] = userId;
            offerShift['day_abbr'] = originalShiftDay;
            offeredShiftsMap['usersOfferedShifts'][userId] = offeredShiftsMap['usersOfferedShifts'][userId] || {weeklyHours: 0, days: {}};
            offeredShiftsMap['usersOfferedShifts'][userId]['weeklyHours'] += ((new Date(offerShift['end_time']).getTime() - new Date(offerShift['start_time']).getTime()) / 1000 / 3600);
            offeredShiftsMap['usersOfferedShifts'][userId]['days'][originalShiftDay] = offeredShiftsMap['usersOfferedShifts'][userId]['days'][originalShiftDay] || {shifts: []};
            offeredShiftsMap['usersOfferedShifts'][userId]['days'][originalShiftDay]['shifts'].push(offerShift);
        };

        var prepareUsersOfferedShiftsMap = function (offeredShiftsList) {
            var offeredShiftsMap = {pickedUpShifts: {}, usersOfferedShifts: {}};

            for (var i in offeredShiftsList) {
                var offeredObject = offeredShiftsList[i];
                var originalAssigneeShift = offeredObject['original_assignee_shift'];
                var destinationAssigneeShift = offeredObject['destination_assignee_shift'];

                if (offeredObject['type'] !== 'UNASSIGNED' && originalAssigneeShift) {
                    addOfferedShiftDetails(offeredObject['from_user_id'], originalAssigneeShift, offeredShiftsMap);

                    if (offeredObject['type'] === 'SWAP') {
                        originalAssigneeShift['user_id'] = offeredObject['from_user_id'];
                        offeredShiftsMap['pickedUpShifts'][originalAssigneeShift['unpublished_assignee_shift_id']] = originalAssigneeShift;
                    }
                }

                if (destinationAssigneeShift && destinationAssigneeShift['unpublished_assignee_shift_id'] && offeredObject['type'] !== 'DROP') {
                    destinationAssigneeShift['user_id'] = offeredObject['to_user_id'];
                    offeredShiftsMap['pickedUpShifts'][destinationAssigneeShift['unpublished_assignee_shift_id']] = destinationAssigneeShift;

                    if (offeredObject['type'] === 'SWAP') {
                        addOfferedShiftDetails(offeredObject['to_user_id'], destinationAssigneeShift, offeredShiftsMap);
                    }
                }
            }

            return offeredShiftsMap;
        };

        var prepareUsersConsentMap = function (consentList) {
            var consentsMap = {};

            for (var i in consentList) {
                var consentObject = consentList[i];
                var userId = consentObject.user_id;
                var shiftId = consentObject.assignee_shift.reference_id;
                consentsMap[userId] = consentsMap[userId] || {};
                if (consentsMap[userId][shiftId]) {
                    var firstShiftSubmissionTime = new Date(consentsMap[userId][shiftId].submission_time).getTime();
                    var secondShiftSubmissionTime = new Date(consentObject.submission_time).getTime();

                    if (secondShiftSubmissionTime > firstShiftSubmissionTime) {
                        consentsMap[userId][shiftId] = consentObject;
                    }
                } else {
                    consentsMap[userId][shiftId] = consentObject;
                }
            }

            return consentsMap;
        }

        var prepareScheduleShifts = function () {
            var scheduleDataMap = ScheduleDataServiceV2.flatData['shifts'];
            var crossSchedulesDataMap = ScheduleDataServiceV2.usersCrossLocationShifts;
            var scheduleFlatData = [];
            var crossSchedulesFlatData = [];

            for (var i in scheduleDataMap) {
                var shift = scheduleDataMap[i];

                shift['day_abbr'] = moment(shift.day).format('ddd').toUpperCase();
                scheduleFlatData.push(shift);
            }

            for (var c in crossSchedulesDataMap) {
                var userShifts = crossSchedulesDataMap[c];

                for (var i in userShifts) {
                    var crossLocationShift = userShifts[i];
                    crossLocationShift['day_abbr'] = moment(crossLocationShift.day).format('ddd').toUpperCase();
                    crossSchedulesFlatData.push(crossLocationShift);
                }
            }

            var allShifts = scheduleFlatData.concat(crossSchedulesFlatData);

            return allShifts;
        }

        var doOverlap = function (shift1Start, shift1End, shift2Start, shift2End) {
            if (
                (shift1Start < shift2Start && shift1End <= shift2Start) ||
                (shift1End > shift2End && shift1Start >= shift2End)
            ) {
                return false;
            }

            return true;
        };

        let setGFEViolationTypes = function (violationTypes, templateSettings, gfeState) {
            let violations = [];

            if (!templateSettings.isNYCRegularSchedule && violationTypes?.length > 0) {
                violations = violationTypes;
            } else {
                if (
                    WARNING_JURISDICTION_MAP.WORKING_LOCATION.indexOf(gfeState) > -1 &&
                    (
                        !templateSettings.isNYCRegularSchedule ||
                        templateSettings.location_variation_enabled
                    )
                ) {
                    violations.push({code: "WORKING_LOCATION"});
                }
                if (WARNING_JURISDICTION_MAP.WORKING_DAYS.indexOf(gfeState) > -1) {
                    violations.push({code: "WORKING_DAYS"});
                }
                if (WARNING_JURISDICTION_MAP.WORKING_HOURS_WINDOW.indexOf(gfeState) > -1) {
                    violations.push({code: "WORKING_HOURS_WINDOW"});
                }
                if (WARNING_JURISDICTION_MAP.WORKING_HOURS_RESTRICTED.indexOf(gfeState) > -1) {
                    violations.push({code: "WORKING_HOURS_RESTRICTED"});
                }
                if (WARNING_JURISDICTION_MAP.REGULAR_SCHEDULE_VARIATION.indexOf(gfeState) > -1) {
                    violations.push({code: "REGULAR_SCHEDULE_VARIATION"});
                }
                if (WARNING_JURISDICTION_MAP.TOTAL_HOURS.indexOf(gfeState) > -1) {
                    violations.push({code: "TOTAL_HOURS"});
                }
            }

            if (WARNING_JURISDICTION_MAP.NO_EFFECTIVE_GFE.indexOf(gfeState) > -1) {
                violations.push({code: "NO_EFFECTIVE_GFE"});
            }

            if (WARNING_JURISDICTION_MAP.NOT_SCHEDULED.indexOf(gfeState) > -1) {
                violations.push({code: "NOT_SCHEDULED"});
            }

            return violations;
        }

        var hasGFEViolation = function (violations, code) {
            return !!_.findWhere(violations, {code: code});
        };

        var getGFENonCoveredDays = function (gfeUser) {
            var nonCoveredDays = [];
            var startDate = angular.copy(ScheduleDataServiceV2.startDate);
            var effectiveStartDate = gfeUser.effectiveStartDate;

            for (var i = 0; i < 7; i++) {
                var date = moment(startDate).valueOf();
                if (date < effectiveStartDate) {
                    nonCoveredDays.push(startDate);
                } else {
                    break;
                }
                startDate = moment(startDate, "MMM DD, YYYY").add(1, 'day');
            }

            return nonCoveredDays;
        };

        var calculateOverlapBetweenGfeShiftAndAvailability = function (gfeShift, userId) {
            var dayOpen = ShiftTemplateUtils.secondsToTimeObj(ScheduleDataServiceV2.dayOpenHour / 1000);
            var userAvailabilities = ScheduleDataServiceV2.availabitlies[userId] || [];
            var excludedHours = 0;

            var dayOpenTime = moment(gfeShift.start_time).hours(dayOpen.hours).minutes(dayOpen.minutes).valueOf();

            gfeShift.start_time = new Date(gfeShift.start_time).getTime();
            gfeShift.end_time = new Date(gfeShift.end_time).getTime();

            if (gfeShift.start_time < dayOpenTime) {
                gfeShift.start_time += DAY;
            }

            if (gfeShift.end_time <= gfeShift.start_time) {
                gfeShift.end_time += DAY;
            }

            for (var i in userAvailabilities) {
                var interval = userAvailabilities[i];
                if (["AVAILABILITY", "LOA", "TIME_OFF", "PATERNITY", "BEREAVEMENT", "MATERNITY", "SHARED_PARENTAL", "ADOPTION", "CUSTOM", "COMPANY_HOLIDAY", "STATUTORY_HOLIDAY"].indexOf(interval.type) > -1) {
                    var isOverlapped = doOverlap(interval.start_time, interval.end_time, gfeShift.start_time, gfeShift.end_time);

                    if (isOverlapped) {
                        var overlapStart = interval.start_time > gfeShift.start_time ? interval.start_time : gfeShift.start_time;
                        var overlapEnd = interval.end_time < gfeShift.end_time ? interval.end_time : gfeShift.end_time;
                        var overlapDifference = (overlapEnd - overlapStart) / (3600 * 1000);
                        if (overlapDifference > 0) {
                            excludedHours += overlapDifference;

                        }
                    }
                }
            }
            return excludedHours;
        }

        var prepareExcludedHoursForRegularShifts = function (userId, userGFEWork) {
            var totalExcludedHours = 0;
            var gfeAllIntervals = userGFEWork['allIntervals'];

            for (var s in gfeAllIntervals) {
                var gfeShift = angular.copy(gfeAllIntervals[s]);
                totalExcludedHours += calculateOverlapBetweenGfeShiftAndAvailability(gfeShift, userId)
            }

            return totalExcludedHours;
        }

        var getShiftDuration = function (shift) {
            var shiftStartTime = new Date(shift.start_time).getTime();
            var shiftEndTime = new Date(shift.end_time).getTime();

            return (shiftEndTime - shiftStartTime) / (1000 * 3600);
        }

        var getGFEShiftDuration = function (gfeShift) {
            var startTime = new Date(gfeShift.start_time).getTime();
            var endTime = new Date(gfeShift.end_time).getTime();

            var dayOpen = ShiftTemplateUtils.secondsToTimeObj(ScheduleDataServiceV2.dayOpenHour / 1000);
            var dayOpenTime = moment(gfeShift.start_time).hours(dayOpen.hours).minutes(dayOpen.minutes).valueOf();

            if (startTime < dayOpenTime) {
                startTime += DAY;
            }

            if (endTime <= startTime) {
                endTime += DAY;
            }
           return (endTime - startTime) / (3600 * 1000);
        }

        const checkUserTotalHoursViolation = (userWork, userGFEWork, startOfWeek, isNYCRegularSchedule) => {
            var totalHoursViolation = {
                hasTotalHoursViolation: false,
                totalHoursPercentage: 0,
            }
            var totalWeeklyHours = Utils.roundFloat(userWork['weeklyHours']);
            var gfeWeeklyHours = userGFEWork['weeklyHours'];

            if (
                userGFEWork['effectiveStartDate'] <= startOfWeek &&
                totalWeeklyHours !== gfeWeeklyHours
            ) {

                var totalHoursPercentage = Utils.roundFloat(((totalWeeklyHours / gfeWeeklyHours) * 100) - 100);

                var variationPercentage = isNYCRegularSchedule ? 15 : 20;

                if (Math.abs(totalHoursPercentage) >= variationPercentage) {
                    totalHoursViolation.hasTotalHoursViolation = true;
                    totalHoursViolation.totalHoursPercentage = totalHoursPercentage;
                }
            }

            return totalHoursViolation;
        }

        var checkUserRegularScheduleVariatons = function (userId, userGFEWork, userVariationHours, userWork) {
            var variationHoursObj = {
                hasRegularScheduleVariation: false,
                variationHoursPercentage: 0,
            }

            userVariationHours = userVariationHours || 0;

            if (userWork) {
                // check all intervals and add the duration of every gfe shifts that is not overlapped with any shift to usersVariationHours
                for (let i in userGFEWork.allIntervals) {
                    var gfeShift = angular.copy(userGFEWork.allIntervals[i]);
                    if (!gfeShift.isOverlapped) {
                        userVariationHours += getGFEShiftDuration(gfeShift);
                    }
                }
            }

            if (userVariationHours) {
                if (!userGFEWork.isEmptyGFE) {
                    // The warning isn't shown for documents that are not effective at the start of the week
                    if (!userGFEWork.isMidweekEffectiveDate) {

                        // calculate hours that are excluded from variation calculations
                        // this includes time off hours and temporary availability change
                        var excludedHours = prepareExcludedHoursForRegularShifts(userId, userGFEWork);

                    // calculate the variation hours percentage from the gfeWeeklyHours
                    // calculate the percentage of excluded hours from the gfeWeekly hours
                    // subtract the excluded percentage from the variation hours percentage
                    // if the resulting variation hours percentage is greater than 15%, push the employee level warning REGULAR_SCHEDULE_VARIATION
                    var gfeWeeklyHours = userGFEWork['weeklyHours'];
                    var variationHoursPercentage = Utils.roundFloat(((userVariationHours / gfeWeeklyHours) * 100));

                    if (excludedHours > 0) {
                        var excludedHoursPercentage = Utils.roundFloat((excludedHours / gfeWeeklyHours) * 100);
                        variationHoursPercentage -= excludedHoursPercentage;
                    }

                        variationHoursObj['variationHoursPercentage'] = variationHoursPercentage;
                        variationHoursObj['hasRegularScheduleVariation'] = (Math.abs(variationHoursPercentage) > 15);
                    }
                }
                else {
                    // if the regular schedule is empty, the variation percentage is always 100%
                    variationHoursObj['variationHoursPercentage'] = 100;
                    variationHoursObj['hasRegularScheduleVariation'] = true;
                }
            }

            return variationHoursObj;
        }

        const checkIfUserMissedGFESchedule = (isNYCRegularSchedule, userId, usersWorkingMap, usersOfferedShiftsMap, userGFEWork, userPayType) => {
            var isUserMissedGFESchedule = false;
            var scheduledUserIds = Object.keys(usersWorkingMap);
            var offeredShiftsUserIds = Object.keys(usersOfferedShiftsMap['usersOfferedShifts']);
            var usersIds = scheduledUserIds.concat(offeredShiftsUserIds);

            if (userPayType && userPayType['type'] === 'HOURLY' && usersIds.indexOf(userId) === -1) {
                if (isNYCRegularSchedule) {
                    var gfeAllIntervals = userGFEWork['allIntervals'] || [];

                    for (var i = 0; i < gfeAllIntervals.length; i++) {
                        var gfeShift = angular.copy(gfeAllIntervals[i]);
                        var gfeShiftDuration = getGFEShiftDuration(gfeShift);
                        var overlappedHours = calculateOverlapBetweenGfeShiftAndAvailability(gfeShift, userId);

                        if ((overlappedHours === 0) ||
                            overlappedHours < gfeShiftDuration) {
                            isUserMissedGFESchedule = true;
                            break;
                        }
                    }
                } else {
                    isUserMissedGFESchedule = true;
                }
            }

            return isUserMissedGFESchedule;
        };

        /**
         * the GFE is required for all other jurisdiction if the user doesn't have a GFE document returned
         * in the case of CHICAGO GFE then the GFE is required only if the user doesn't have an active GFE document and the date provided is same or before the hire date of the user + 90 days
         * @param goodFaithEstimateUsersMap users gfe documents map
         * @param userId the user id
         * @param gfeState the configuration gfe state for the brand
         * @param date the date to do the check on (for now this only needed for CHICAGO state)
         * @returns {boolean} returns true if the GFE is required, and false otherwise, read the description of the function to understand more about the handling of CHICAGO state.
         */
        const checkIfGFEIsRequired = (goodFaithEstimateUsersMap, userId, gfeState, date) => {
            if (gfeState === GFE_JURISICTIONS.CHICAGO) {
                return (
                    !goodFaithEstimateUsersMap[userId] &&
                    self.checkChicagoGFEExpiration(userId, date)
                )
            }
            return !goodFaithEstimateUsersMap[userId];
        }

        self.checkChicagoGFEExpiration = (userId, date) => {
            const userDetails = TSUsersService.users[userId];
            return userDetails &&
                moment(date).isSameOrBefore(moment(userDetails.hire_date).add(AUTO_EXPIRATION_RANGE_AFTER_HIRE_DATE.CHICAGO, "days"));
        }

        self.calculateGFEWarnings = function (brandId) {
            var defer = $q.defer();

            var scheduleSettings = ScheduleDataServiceV2.getBrandScheduleSettings();

            var isEmployeeConsentFlowEnabled = (scheduleSettings['fair_work_week_settings'] &&
                scheduleSettings['fair_work_week_settings']['penalty_general_settings'] &&
                scheduleSettings['fair_work_week_settings']['penalty_general_settings'].employee_consent_flow_enabled);


            var promises = {
                'gfeTemplates': self.getGFETemplates(brandId),
                'isGFEServiceEnabled': userServices.isServiceEnabled(userServices.SERVICES.GFE_INCIDENTS_TRACKING, brandId),
            }

            $q.all(promises).then(function (result) {
                if (result['gfeTemplates'] && result['gfeTemplates'].length > 0) {
                    var postPromises = {
                        'goodFaithEstimateUsers': self.getGFEIntervals(brandId, ScheduleDataServiceV2.startDate),
                        'offeredShifts': ScheduleDataServiceV2.getBrandShiftsOffers(brandId, ScheduleDataServiceV2.startDate),
                        'usersCostsMap': ScheduleCostsServiceV2.getUsersCostsMap(),
                    };

                    let gfeState = result.gfeTemplates[0]?.code;
                    let isNYCRegularSchedule = gfeState && gfeState === GFE_JURISICTIONS.NYC;
                    var isGFEServiceEnabled = result['isGFEServiceEnabled'];

                    if (isGFEServiceEnabled) {
                        postPromises['goodFaithEstimateSettings'] = self.getGFEBrandSettings(brandId);
                    }

                    if (isNYCRegularSchedule) {
                        postPromises['nycTemplateSettings'] = self.getGFETemplateSettings(brandId);
                        postPromises['usersWithPendingGFE'] = self.getUsersWithPendingGFE(brandId);
                        if (isEmployeeConsentFlowEnabled) {
                            postPromises['userShiftConsents'] = getRequestedConsentList(brandId, ScheduleDataServiceV2.startDate);
                        }
                    }

                    $q.all(postPromises).then(function (res) {
                        var goodFaithEstimateSettings = res['goodFaithEstimateSettings'] || {};
                        var startOfWeek = moment(ScheduleDataServiceV2.startDate).valueOf();
                        var dayOpen = ShiftTemplateUtils.secondsToTimeObj(ScheduleDataServiceV2.dayOpenHour / 1000);
                        var nycTemplateSettings = res['nycTemplateSettings'] && res['nycTemplateSettings']['settings'] || {};

                        var usersCostsMap = res['usersCostsMap'] || {};

                        const gfeIncidentTrackingState = goodFaithEstimateSettings?.settings?.state;
                        var warningsObject = isNYCRegularSchedule ? REGULAR_SCHEDULE_WARNINGS_TYPES : GFE_WARNINGS_TYPES;
                        nycTemplateSettings["isNYCRegularSchedule"] = isNYCRegularSchedule;

                        let violationTypes = setGFEViolationTypes(goodFaithEstimateSettings['violation_types'], nycTemplateSettings, gfeState);

                        var goodFaithEstimateUsersMap = prepareGFEUserMap(angular.copy(res['goodFaithEstimateUsers']['users']) || []);
                        var usersOfferedShiftsMap = prepareUsersOfferedShiftsMap(res['offeredShifts'] || []);
                        var userConsentsMap = prepareUsersConsentMap(res['userShiftConsents'] || []);
                        var gfeViolationsWarnings = [];

                        var allUserShifts = prepareScheduleShifts();
                        var usersWorkingMap = prepareUsersWorkingMap(allUserShifts, usersCostsMap, goodFaithEstimateUsersMap, usersOfferedShiftsMap);

                        // userVariationHours is added during the calculation of other warnings in order to calculate the regular schedule variation warning
                        var usersVariationHours = {}

                        let checkNoEffectiveGfeWarning = hasGFEViolation(violationTypes, VIOLATION_TYPES.NO_EFFECTIVE_GFE);
                        if (checkNoEffectiveGfeWarning) {
                            // check all scheduled users including ones without shifts
                            let allScheduleUsers = ScheduleDataServiceV2.flatData['users'];
                            for (let userId in allScheduleUsers) {
                                if (checkIfGFEIsRequired(goodFaithEstimateUsersMap, userId, gfeState, ScheduleDataServiceV2.startDate)) {
                                    // if the user has no gfe document, push the NO_EFFECTIVE_GFE warning
                                    gfeViolationsWarnings.push({
                                        code: warningsObject.NO_EFFECTIVE_GFE,
                                        userId: parseInt(userId),
                                    });
                                }
                            }
                        }

                        // Iterate over users with shifts on the schedule
                        for (var userId in usersWorkingMap) {
                            var userWork = usersWorkingMap[userId];
                            var userGFEWork = goodFaithEstimateUsersMap[userId];
                            usersVariationHours[userId] = 0;

                            if (userGFEWork) {
                                // if the document is not effective at the start of the week, calculate the days not covered by gfe
                                if (userGFEWork.isMidweekEffectiveDate) {
                                    var userDetails = TSUsersService.users[userId];

                                    if (userDetails && moment(ScheduleDataServiceV2.startDate).isSameOrAfter(moment(userDetails.hire_date))) {
                                        var nonCoveredDays = getGFENonCoveredDays(userGFEWork);
                                        gfeViolationsWarnings.push({
                                            code: warningsObject.NO_EFFECTIVE_GFE,
                                            userId: parseInt(userId),
                                            nonCoveredDays: nonCoveredDays,
                                        });
                                    }
                                }

                                // Check significant change if the brand has the gfe incidents service and not an nyc location
                                if (
                                    !isNYCRegularSchedule &&
                                    gfeIncidentTrackingState &&
                                    userGFEWork['hasSignificantChange']
                                ) {
                                    gfeViolationsWarnings.push({
                                        code: warningsObject.HAS_SIGNIFICANT_CHANGE,
                                        userId: parseInt(userId),
                                    });
                                }

                                // Check total hours warning
                                // Compare total hours on the schedule with total hours of the gfe document
                                // If the total hours difference percentage is higher than 20% push employee levvel warning TOTAL_HOURS
                                // Does not apply to NYC
                                // Not shown in case the gfe document is not effective from the start of the week
                                var checkTotalHoursViolation = hasGFEViolation(violationTypes, VIOLATION_TYPES.TOTAL_HOURS);
                                if (checkTotalHoursViolation && !userGFEWork.isMidweekEffectiveDate) {
                                    const totalHoursViolation = checkUserTotalHoursViolation(userWork, userGFEWork, startOfWeek, isNYCRegularSchedule);
                                    if (totalHoursViolation.hasTotalHoursViolation) {
                                        gfeViolationsWarnings.push({
                                            code: warningsObject.TOTAL_HOURS,
                                            totalHoursPercentage: totalHoursViolation.totalHoursPercentage,
                                            userId: parseInt(userId),
                                        });
                                    }
                                }

                                // Check all user schedule shifts per day
                                for (var i in userWork['days']) {
                                    var userGFEWorkForDay = userGFEWork['days'][i];
                                    var userWorkForDay = userWork['days'][i];

                                    for (var j in userWorkForDay['shifts']) {
                                        var shift = userWorkForDay['shifts'][j];
                                        var shiftDay = shift.day_abbr;
                                        var isOffered = (
                                            !!usersOfferedShiftsMap['usersOfferedShifts'][userId] &&
                                            usersOfferedShiftsMap['usersOfferedShifts'][userId]['days'][shift.day_abbr] &&
                                            usersOfferedShiftsMap['usersOfferedShifts'][userId]['days'][shift.day_abbr]['shifts']
                                                .find(function (offeredShift) {
                                                    return shift.id === offeredShift.unpublished_assignee_shift_id;
                                                })
                                        );

                                        if (isOffered) {
                                            continue;
                                        }

                                        if (userGFEWorkForDay) {
                                            // check if the shift's location is included on the gfe for the day
                                            // if the gfe doesn't have any shifts on this location, push shift level warning WORKING_LOCATION
                                            var checkLocationViolation = hasGFEViolation(violationTypes, VIOLATION_TYPES.WORKING_LOCATION);
                                            var userGFEWorkForLocation = userGFEWorkForDay['locations'][shift.brand_id];

                                            if (checkLocationViolation && !userGFEWorkForLocation) {

                                                // the shift's duration is added to usersVariationHours
                                                if (isNYCRegularSchedule) {
                                                    usersVariationHours[userId] += getShiftDuration(shift);
                                                }

                                                gfeViolationsWarnings.push({
                                                    code: warningsObject.WORKING_LOCATION,
                                                    userId: parseInt(userId),
                                                    shift: shift,
                                                    brandId: shift.brand_id
                                                });

                                                continue;
                                            }

                                            // WORKING_HOURS_WINDOW applies to all gfe locations except nyc
                                            // WORKING_HOURS_RESTRICTED applies only to nyc
                                            var checkShiftTimingWindowViolation = hasGFEViolation(violationTypes, VIOLATION_TYPES.WORKING_HOURS_WINDOW);
                                            var checkShiftTimingViolation = hasGFEViolation(violationTypes, VIOLATION_TYPES.WORKING_HOURS_RESTRICTED);
                                            var gfeShifts = [];

                                            for (var l in userGFEWorkForDay['locations']) {
                                                gfeShifts = gfeShifts.concat(userGFEWorkForDay['locations'][l]['shifts']);
                                            }


                                            if (gfeShifts.length && (checkShiftTimingWindowViolation || checkShiftTimingViolation)) {
                                                var shiftStartTime = new Date(shift.start_time).getTime();
                                                var shiftEndTime = new Date(shift.end_time).getTime();
                                                var isOverlapped = false;

                                                // compare shift to all gfe shifts for the day to find overlap
                                                for (var s in gfeShifts) {
                                                    var gfeShift = angular.copy(gfeShifts[s]);
                                                    var dayOpenTime = moment(gfeShift.start_time).hours(dayOpen.hours).minutes(dayOpen.minutes).valueOf();
                                                    var originalStart = new Date(gfeShift.start_time).getTime();

                                                    gfeShift.start_time = new Date(gfeShift.start_time).getTime();
                                                    gfeShift.end_time = new Date(gfeShift.end_time).getTime();

                                                    if (gfeShift.start_time < dayOpenTime) {
                                                        gfeShift.start_time += DAY;
                                                    }

                                                    if (gfeShift.end_time <= gfeShift.start_time) {
                                                        gfeShift.end_time += DAY;
                                                    }

                                                    isOverlapped = doOverlap(shiftStartTime, shiftEndTime, gfeShift.start_time, gfeShift.end_time);

                                                    if (isNYCRegularSchedule && nycTemplateSettings.location_variation_enabled) {
                                                        isOverlapped = isOverlapped && (shift.brand_id === brandId);
                                                    }

                                                    var startTimeDifference = 0;
                                                    var endTimeDifference = 0;

                                                    // if overlap is found, calculate the difference in timing between the gfe shift and the current shift
                                                    if (isOverlapped) {

                                                        // mark the gfe as overlapped in the allIntervals array
                                                        // this is to calculate the hours of gfe shifts that do not overlap any shifts
                                                        var gfeShiftObject = userGFEWork.allIntervals.find(function (shift) {
                                                            return originalStart === new Date(shift.start_time).getTime() && gfeShift.brand_id === shift.brand_id;
                                                        });

                                                        gfeShiftObject.isOverlapped = true;

                                                        // for WORKING_HOURS_WINDOW
                                                        // if the shift starts before the comparable gfe shift and ends before it, the warning isn't shown
                                                        // otherwise the difference between start times and end times is calculated
                                                        if (checkShiftTimingWindowViolation) {
                                                            if (shiftStartTime >= gfeShift.start_time && shiftEndTime <= gfeShift.end_time) {
                                                                break;
                                                            }

                                                            if (shiftStartTime < gfeShift.start_time) {
                                                                startTimeDifference = (gfeShift.start_time - shiftStartTime) / 1000;
                                                            }

                                                            if (shiftEndTime > gfeShift.end_time) {
                                                                endTimeDifference = (shiftEndTime - gfeShift.end_time) / 1000;
                                                            }
                                                        }

                                                        // for WORKING_HOURS_RESTRICTED
                                                        // if the shift times match the gfe shift times, the warning will not be shown
                                                        // if the shift is requested by assignee or is consented by the employee, the warning will not be shown
                                                        // otherwise the difference between start times and end times is calculated
                                                        // the sum of the differences is added to the usersVariationHours
                                                        if (checkShiftTimingViolation) {
                                                            if (shift.is_requested_by_assignee || (shiftStartTime === gfeShift.start_time && shiftEndTime === gfeShift.end_time)) {
                                                                break;
                                                            } else if (userConsentsMap[userId] && userConsentsMap[userId][shift.id]) {
                                                                var consentedShift = userConsentsMap[userId][shift.id];
                                                                var consentedShiftStartTime = new Date(consentedShift.start_time).getTime();
                                                                var consentedShiftEndTime = new Date(consentedShift.end_time).getTime();
                                                                if (shiftStartTime === consentedShiftStartTime && shiftEndTime === consentedShiftEndTime) {
                                                                    break;
                                                                }
                                                            }

                                                            startTimeDifference = Math.abs((gfeShift.start_time - shiftStartTime) / 1000);
                                                            endTimeDifference = Math.abs((gfeShift.end_time - shiftEndTime) / 1000);
                                                            usersVariationHours[userId] += (startTimeDifference + endTimeDifference) / 3600;
                                                        }

                                                        // if the sum of differences is larger than the set window, push shift level warning WORKING_HOURS_WINDOW
                                                        var variationWindow = checkShiftTimingViolation ? 60 : 3600;

                                                        if (
                                                            shift.brand_id === brandId &&
                                                            (
                                                                (
                                                                    gfeIncidentTrackingState !== 'PL' &&
                                                                    (startTimeDifference + endTimeDifference) === variationWindow
                                                                ) ||
                                                                (startTimeDifference + endTimeDifference) > variationWindow
                                                            )
                                                        ) {
                                                            gfeViolationsWarnings.push({
                                                                code: warningsObject.WORKING_HOURS_WINDOW,
                                                                userId: parseInt(userId),
                                                                shift: shift,
                                                                start_time: gfeShift.start_time,
                                                                end_time: gfeShift.end_time,
                                                                difference: startTimeDifference + endTimeDifference,
                                                            });
                                                        }
                                                    }
                                                }

                                                // if the shift did not overlap with any gfe shift push the shift levle warning WORKING_HOURS_WINDOW
                                                // add the sum of time differences to usersVariationHours
                                                if (!isOverlapped) {

                                                    var timeDifference = startTimeDifference + endTimeDifference;

                                                    if (checkShiftTimingViolation) {
                                                        timeDifference = Math.abs((shiftEndTime - shiftStartTime) / 1000);
                                                        usersVariationHours[userId] += (timeDifference) / 3600;
                                                    }

                                                    if (shift.brand_id === brandId) {
                                                        gfeViolationsWarnings.push({
                                                            code: warningsObject.WORKING_HOURS_WINDOW,
                                                            userId: parseInt(userId),
                                                            shift: shift,
                                                            start_time: gfeShifts[0].start_time,
                                                            end_time: gfeShifts[0].end_time,
                                                            difference: timeDifference,
                                                        });
                                                    }
                                                }

                                            }
                                        } else {
                                            // if the user doesn't have any gfe work on the day of the shift, push shift level warning WORKING_DAYS
                                            var checkWorkingDaysViolation = hasGFEViolation(violationTypes, VIOLATION_TYPES.WORKING_DAYS);

                                            if (checkWorkingDaysViolation) {
                                                gfeViolationsWarnings.push({
                                                    code: warningsObject.WORKING_DAYS,
                                                    userId: parseInt(userId),
                                                    dayType: 'NON_WORKING_DAY',
                                                    day: shiftDay,
                                                    shift: shift,
                                                });

                                                // add the shift duration to usersVariationHours
                                                usersVariationHours[userId] += getShiftDuration(shift);
                                            }
                                        }
                                    }
                                }

                                // check for all days in the gfe document
                                for (var k in userGFEWork['days']) {
                                    var userGFEWorkForDay = userGFEWork['days'][k];
                                    var userWorkForDay = userWork['days'][k];
                                    var userOfferedShiftsForDay = usersOfferedShiftsMap['usersOfferedShifts'][userId] && usersOfferedShiftsMap['usersOfferedShifts'][userId]['days'][k];
                                    var userGFEWorkForLocation = userGFEWorkForDay['locations'][brandId];

                                    var checkWorkingDaysViolation = hasGFEViolation(violationTypes, VIOLATION_TYPES.WORKING_DAYS);

                                    // if the user doesn't have shifts on the schedule push the WORKING_DAYS warning
                                    if (checkWorkingDaysViolation) {
                                        if (!userWorkForDay && !userOfferedShiftsForDay) {
                                            gfeViolationsWarnings.push({
                                                code: warningsObject.WORKING_DAYS,
                                                userId: parseInt(userId),
                                                dayType: 'WORKING_DAY',
                                                day: k
                                            });
                                        }
                                    }

                                    var checkLocationViolation = hasGFEViolation(violationTypes, VIOLATION_TYPES.WORKING_LOCATION);

                                    if (checkLocationViolation) {
                                        // if the user has gfe work for this location on this day, check the scheduled user shifts for this location
                                        if (userGFEWorkForLocation) {
                                            var userShifts = userWorkForDay && userWorkForDay['shifts'] || [];
                                            var userShiftsForLocation = _.filter(userShifts, function (shift) {
                                                return shift.brand_id === brandId;
                                            });

                                            // if the user has scheduled shifts for the day but no shifts on this location, push the shift level warning WORKING_LOCATION for each of the scheduled shifts
                                            if (
                                                userShifts.length &&
                                                userShiftsForLocation.length === 0
                                            ) {
                                                for (var index in userShifts) {
                                                    var shift = userShifts[index];

                                                    if (isNYCRegularSchedule) {
                                                        usersVariationHours[userId] += getShiftDuration(shift);
                                                    }

                                                    gfeViolationsWarnings.push({
                                                        code: warningsObject.WORKING_LOCATION,
                                                        userId: parseInt(userId),
                                                        brandId: brandId,
                                                        shift: shift
                                                    });
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        // check for pending documents warning
                        if (isNYCRegularSchedule) {
                            var regularScheduleUsersWithPendingDocumentMap = {};
                            if (res['usersWithPendingGFE'] && res['usersWithPendingGFE'].length) {
                                regularScheduleUsersWithPendingDocumentMap = prepareRegularScheduleUsersWithPendingDocumentMap(res['usersWithPendingGFE']);
                            }
                            var userIdWithPendingGfe = Object.keys(regularScheduleUsersWithPendingDocumentMap);
                            for (var u in userIdWithPendingGfe) {
                                var userId = userIdWithPendingGfe[u];
                                for (var d in regularScheduleUsersWithPendingDocumentMap[userId]) {
                                    var document = regularScheduleUsersWithPendingDocumentMap[userId][d]
                                    gfeViolationsWarnings.push({
                                        code: warningsObject.HAS_PENDING_GFE,
                                        documentDetails: document,
                                        userId: parseInt(userId),
                                    });
                                }
                            }
                        }

                        var gfeUserIds = Object.keys(goodFaithEstimateUsersMap);

                        // for all gfe users, check Regular Schedule Variations and missing schedule warnings
                        for (var j in gfeUserIds) {
                            var userId = gfeUserIds[j];
                            var userGFEWork = goodFaithEstimateUsersMap[userId];
                            var userWork = usersWorkingMap[userId];
                            var userCosts = usersCostsMap[userId] || {};
                            var userPayType = userCosts["pay_type"] && userCosts["pay_type"][Object.keys(userCosts["pay_type"])[0]];

                            if (isNYCRegularSchedule) {
                                var variationHoursObj = checkUserRegularScheduleVariatons(userId, userGFEWork, usersVariationHours[userId], userWork);

                                if (variationHoursObj.hasRegularScheduleVariation) {
                                    gfeViolationsWarnings.push({
                                        code: warningsObject.REGULAR_SCHEDULE_VARIATION,
                                        totalHoursPercentage: variationHoursObj.variationHoursPercentage,
                                        userId: parseInt(userId),
                                    });
                                }
                            }

                            let checkNotScheduledWarning = hasGFEViolation(violationTypes, VIOLATION_TYPES.NOT_SCHEDULED);
                            let isNotScheduledUser = checkNotScheduledWarning && checkIfUserMissedGFESchedule(isNYCRegularSchedule, userId, usersWorkingMap, usersOfferedShiftsMap, userGFEWork, userPayType);
                            if (isNotScheduledUser) {
                                gfeViolationsWarnings.push({
                                    code: warningsObject.NOT_SCHEDULED,
                                    userId: parseInt(userId),
                                });
                            }
                        }

                        defer.resolve(gfeViolationsWarnings);

                    }).catch(function (err) {
                        console.error(err);
                        defer.resolve([]);
                    });
                }
                else {
                    defer.resolve([]);
                }
            })
                .catch(function (err) {
                console.error(err);
                defer.resolve([]);
            });



            return defer.promise;
        };

        var prepareRegularScheduleUsersWithPendingDocumentMap = function (usersWithPendingGFE) {
            var regularScheduleUsersWithPendingDocumentMap = {};
            for (var i in usersWithPendingGFE) {
                var user = usersWithPendingGFE[i];
                regularScheduleUsersWithPendingDocumentMap[user.id] = user.documents;
            }
            return regularScheduleUsersWithPendingDocumentMap;
        }

        self.getGFEBrandSettings = function (brandId) {
            var defer = $q.defer();

            if (cache['gfeSettings']) {
                defer.resolve(cache['gfeSettings']);
            } else {
                GoodFaithEstimateAPI.getGFEBrandSettings(brandId)
                    .then(function (gfeSettings) {
                        cache['gfeSettings'] = gfeSettings;
                        defer.resolve(gfeSettings);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        var getRequestedConsentList = function (brandId, date) {
            var defer = $q.defer();

            var params = {
                is_requested_by_assignee: true,
                from_date: moment(date).format('YYYY-MM-DD'),
                to_date: moment(date).add(7, 'days').format('YYYY-MM-DD'),
                limit: 100,
                status: 'APPROVED',
            }

            TeamScheduleAPI.getBrandScheduledShiftsConsents(brandId, params)
                .then(function (consents) {
                    defer.resolve(consents);
                })
                .catch(function (err) {
                    defer.resolve([]);
                });

            return defer.promise;
        }

        var getActiveGfeUsers = function (users) {
            var allGFEUsers = [];
            for (var i in users) {
                var gfeUser = users[i];
                var userId = gfeUser['id'];
                var user = TSUsersService.users[userId];
                if (user && !user.is_scheduling_member) {
                 continue;
                }

                if (checkIfEmptyGFE(gfeUser)) {
                    allGFEUsers.push(gfeUser);
                }

                for (var j in gfeUser['intervals']) {
                    var interval = gfeUser['intervals'][j];
                    if (user && user.isDateWithinEmploymentPeriod(interval['start_date'])) {
                        allGFEUsers.push(gfeUser);
                        break;
                    }
                }

            }
            return allGFEUsers;
        };

        self.getGFEIntervals = function(brandId, startDate) {
            var defer = $q.defer();

            if (cache['gfeUsers_' + brandId + '_' + startDate]) {
                defer.resolve(cache['gfeUsers_' + brandId + '_' + startDate]);
            } else {
                GoodFaithEstimateAPI.getGFEIntervals(brandId, startDate, ['ACTIVE','SCHEDULED','EXPIRED'])
                    .then(function (goodFaithEstimateUsers) {
                        var activeGFEUsers = { users: getActiveGfeUsers(goodFaithEstimateUsers['users']) };
                        cache['gfeUsers_' + brandId + '_' + startDate] = angular.copy(activeGFEUsers);
                        defer.resolve(activeGFEUsers);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.getUsersWithPendingGFE = function(brandId) {
            var defer = $q.defer();

            if (cache['gfeUserWithPendingDocuments_' + brandId]) {
                defer.resolve(cache['gfeUserWithPendingDocuments_' + brandId]);
            } else {
                GoodFaithEstimateAPI.getUsersWithPendingGFE(brandId)
                    .then(function (usersWithPendingGFE) {
                        cache['gfeUserWithPendingDocuments_' + brandId] = angular.copy(usersWithPendingGFE['users']);
                        defer.resolve(usersWithPendingGFE['users']);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.getGFETemplates = function (brandId) {
            var defer = $q.defer();

            if (gfeTemplateCache[brandId]) {
                defer.resolve(angular.copy(gfeTemplateCache[brandId]));
            } else {
                OnBoardingAPI.getDocumentLookupCode('GFE', {brand_ids: [brandId]})
                    .then(function (templates) {
                        gfeTemplateCache[brandId] = templates;
                        defer.resolve(angular.copy(gfeTemplateCache[brandId]));
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.setGFEState = (state) => {
            gfeState = state;
        };

        self.isGFEStateChicago = () => {
            return gfeState === GFE_JURISICTIONS.CHICAGO;
        };

        self.isNYCRegularSchedule = () => {
            return gfeState === GFE_JURISICTIONS.NYC;
        };

        self.getGFETemplateSettings = function (brandId) {
            var defer = $q.defer();

            if (cache['gfeTemplateSettings']) {
                defer.resolve(cache['gfeTemplateSettings']);
            } else {
                GoodFaithEstimateAPI.getGFETemplateSettings(brandId)
                    .then(function (gfeTemplateSettings) {
                        cache['gfeTemplateSettings'] = gfeTemplateSettings;
                        defer.resolve(gfeTemplateSettings);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.getUsersGFE = function (brandId, startWeek) {
            var defer = $q.defer();

            self.getGFETemplates(brandId)
                .then(function (templates) {
                    if (templates.length) {
                        self.getGFEIntervals(brandId, startWeek)
                            .then(function (goodFaithEstimateUsers) {
                                defer.resolve(goodFaithEstimateUsers['users']);
                            })
                            .catch(function (err) {
                                console.error(err);
                                defer.reject(err);
                            });
                    } else {
                        defer.resolve([]);
                    }
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.reset = function () {
            cache = {};
        };

        self.clearGfeTemplatesCache = function () {
            gfeTemplateCache = {};
        };
        var VIOLATION_TYPES = {
            TOTAL_HOURS: "TOTAL_HOURS",
            WORKING_DAYS: "WORKING_DAYS",
            WORKING_LOCATION: "WORKING_LOCATION",
            WORKING_HOURS_RESTRICTED: "WORKING_HOURS_RESTRICTED",
            WORKING_HOURS_WINDOW: "WORKING_HOURS_WINDOW",
            NOT_SCHEDULED: "NOT_SCHEDULED",
            NO_EFFECTIVE_GFE: "NO_EFFECTIVE_GFE",
        };

        var GFE_WARNINGS_TYPES = {
            HAS_SIGNIFICANT_CHANGE: "HAS_SIGNIFICANT_CHANGE",
            NOT_SCHEDULED: "NOT_SCHEDULED",
            NO_EFFECTIVE_GFE: "NO_EFFECTIVE_GFE",
            TOTAL_HOURS: "TOTAL_HOURS",
            WORKING_DAYS: "WORKING_DAYS",
            WORKING_LOCATION: "WORKING_LOCATION",
            WORKING_HOURS_RESTRICTED: "WORKING_HOURS_RESTRICTED",
            WORKING_HOURS_WINDOW: "WORKING_HOURS_WINDOW",
        };

        var REGULAR_SCHEDULE_WARNINGS_TYPES = {
            HAS_SIGNIFICANT_CHANGE: "NYC_HAS_SIGNIFICANT_CHANGE",
            NOT_SCHEDULED: "NYC_NOT_SCHEDULED",
            HAS_PENDING_GFE: "HAS_PENDING_REGULAR_SCHEDULE",
            NO_EFFECTIVE_GFE: "NO_EFFECTIVE_REGULAR_SCHEDULE",
            TOTAL_HOURS: "NYC_TOTAL_HOURS",
            REGULAR_SCHEDULE_VARIATION: "REGULAR_SCHEDULE_VARIATION",
            WORKING_DAYS: "NYC_WORKING_DAYS",
            WORKING_LOCATION: "NYC_WORKING_LOCATION",
            WORKING_HOURS_RESTRICTED: "NYC_WORKING_HOURS_RESTRICTED",
            WORKING_HOURS_WINDOW: "NYC_WORKING_HOURS_WINDOW",
        };

        const GFE_JURISICTIONS = {
            BERKELEY: 'GOOD_FAITH_ESTIMATE_SCHEDULE_BERKELEY',
            CHICAGO: 'GOOD_FAITH_ESTIMATE_SCHEDULE_CHICAGO',
            EMERYVILLE: 'GOOD_FAITH_ESTIMATE_SCHEDULE_EMERYVILLE',
            EVANSTON: 'GOOD_FAITH_ESTIMATE_SCHEDULE_EVANSTON',
            EXPRESS: 'GOOD_FAITH_ESTIMATE_SCHEDULE_EXPRESS',
            LOS_ANGELES: 'GOOD_FAITH_ESTIMATE_SCHEDULE_LOS_ANGELES',
            OREGON: 'GOOD_FAITH_ESTIMATE_SCHEDULE_OREGON',
            PHILADELPHIA: 'GOOD_FAITH_ESTIMATE_SCHEDULE_PHILADELPHIA',
            SAN_FRANCISCO: 'GOOD_FAITH_ESTIMATE_SCHEDULE_SAN_FRANCISCO',
            SEATTLE: 'GOOD_FAITH_ESTIMATE_SCHEDULE_SEATTLE',
            NYC: 'GOOD_FAITH_ESTIMATE_SCHEDULE_LITE',
        }

        const WARNING_JURISDICTION_MAP = {
            NOT_SCHEDULED: [
                GFE_JURISICTIONS.BERKELEY,
                GFE_JURISICTIONS.CHICAGO,
                GFE_JURISICTIONS.EVANSTON,
                GFE_JURISICTIONS.LOS_ANGELES,
                GFE_JURISICTIONS.PHILADELPHIA,
                GFE_JURISICTIONS.SAN_FRANCISCO,
                GFE_JURISICTIONS.NYC
            ],
            NO_EFFECTIVE_GFE: [
                GFE_JURISICTIONS.BERKELEY,
                GFE_JURISICTIONS.CHICAGO,
                GFE_JURISICTIONS.EVANSTON,
                GFE_JURISICTIONS.LOS_ANGELES,
                GFE_JURISICTIONS.PHILADELPHIA,
                GFE_JURISICTIONS.SAN_FRANCISCO,
                GFE_JURISICTIONS.NYC
            ],
            TOTAL_HOURS: [
                GFE_JURISICTIONS.BERKELEY,
                GFE_JURISICTIONS.CHICAGO,
                GFE_JURISICTIONS.EMERYVILLE,
                GFE_JURISICTIONS.EVANSTON,
                GFE_JURISICTIONS.LOS_ANGELES,
                GFE_JURISICTIONS.OREGON,
                GFE_JURISICTIONS.PHILADELPHIA,
                GFE_JURISICTIONS.SEATTLE
            ],
            WORKING_DAYS: [
                GFE_JURISICTIONS.BERKELEY,
                GFE_JURISICTIONS.CHICAGO,
                GFE_JURISICTIONS.EVANSTON,
                GFE_JURISICTIONS.LOS_ANGELES,
                GFE_JURISICTIONS.PHILADELPHIA,
                GFE_JURISICTIONS.NYC
            ],
            WORKING_LOCATION: [
                GFE_JURISICTIONS.BERKELEY,
                GFE_JURISICTIONS.CHICAGO,
                GFE_JURISICTIONS.LOS_ANGELES,
                GFE_JURISICTIONS.NYC
            ],
            WORKING_HOURS_WINDOW: [
                GFE_JURISICTIONS.BERKELEY,
                GFE_JURISICTIONS.CHICAGO,
                GFE_JURISICTIONS.EVANSTON,
                GFE_JURISICTIONS.LOS_ANGELES,
                GFE_JURISICTIONS.PHILADELPHIA
            ],
            WORKING_HOURS_RESTRICTED: [GFE_JURISICTIONS.NYC],
            REGULAR_SCHEDULE_VARIATION: [GFE_JURISICTIONS.NYC],
        }
    }

    app.service('goodFaithEstimateService', GoodFaithEstimateService);
}());